var _mask, _rect, _mask2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 19,
  viewBox: "0 0 16 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1_81_107",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 16,
  rx: 1
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 16,
  rx: 1,
  fill: "white",
  stroke: "#C4C4C4",
  strokeWidth: 3,
  mask: "url(#path-1-inside-1_81_107)"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-2_81_107",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 13,
  height: 16,
  rx: 1
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 13,
  height: 16,
  rx: 1,
  fill: "white",
  stroke: "#C4C4C4",
  strokeWidth: 3,
  mask: "url(#path-2-inside-2_81_107)"
})));
export default SvgCopyIcon;